module.exports = __webpack_public_path__ + "static/media/menu-provas.3aabee49.svg";